module.exports = __webpack_public_path__ + "static/media/background-header.320e41e7.png";